import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { authActions } from "../../../redux-store";
import Classes from "./Auth.module.css";
import Logo from "../Home/Components/Logo/Logo";
import backend from "../../../api";

function Login() {
  const [mode, setMode] = useState("signin"); // "signin" | "forgot"
  const [email, setEmail] = useState("");
  const [psw, setPsw] = useState("");
  const [loading, setLoad] = useState(false);
  const [msg, setMsg] = useState(""); // success / err text
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  /* redirect helper */
  useEffect(() => { if (location.state?.data === "toSignup") navigate("/signup"); }, [location, navigate]);

  /* login */
  const onLogin = async (e) => {
    e.preventDefault(); setLoad(true); setMsg("");
    const ok = await dispatch(authActions.login(email, psw));
    setLoad(false);
    if (ok) {
      const sidebar = sessionStorage.getItem("navBtn");
      navigate(sidebar === "Pitch Deck Templates" ? "/templates" : "/");
    } else setMsg("Incorrect credentials.");
  };

  /* forgot */
  const onForgot = async (e) => {
    e.preventDefault(); setLoad(true); setMsg("");
    try {
      const ok = await dispatch(authActions.forgotPassword(email));
      setMsg(ok ? "Email sent – check your inbox." : "Unknown email address.");
    } catch { setMsg("Network error – try again."); }
    setLoad(false);
  };



  return (
    <div className={Classes.page}>
      <div className={Classes.overlay} />
      <div className={Classes.card}>
        <div className={Classes.logoWrap}>
          <Logo className={Classes.logoIcon} />
        </div>
        {mode === "signin" ? (
          <form onSubmit={onLogin} className={Classes.form}>
            <h2 className={Classes.title}>Welcome Back</h2>
            <p className={Classes.subtitle}>Securely access your account.</p>
            <label className={Classes.label}>Email</label>
            <input
              className={Classes.input}
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label className={Classes.label}>Password</label>
            <input
              className={Classes.input}
              type="password"
              placeholder="Enter your password"
              value={psw}
              onChange={(e) => setPsw(e.target.value)}
              required
            />
            {msg && <p className={msg.startsWith("Email") ? Classes.success : Classes.error}>{msg}</p>}
            <div className={Classes.rowEnd}>
              <button type="button" className={Classes.link} onClick={() => setMode("forgot")}>
                Forgot password?
              </button>
            </div>
            <button className={Classes.btn} disabled={loading}>
              {loading ? <CircularProgress size={18} /> : "Login"}
            </button>
            <p className={Classes.alt}>
              Don’t have an account?{" "}
              <button type="button" className={Classes.link} onClick={() => navigate("/signup")}>
                Sign Up
              </button>
            </p>
          </form>
        ) : (
          <form onSubmit={onForgot} className={Classes.form}>
            <h2 className={Classes.title}>Forgot Password</h2>
            <p className={Classes.subtitle}>Enter your email to reset your password.</p>
            <label className={Classes.label}>Email</label>
            <input
              className={Classes.input}
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {msg && <p className={msg.startsWith("Email") ? Classes.success : Classes.error}>{msg}</p>}
            <button className={Classes.btn} disabled={loading}>
              {loading ? <CircularProgress size={18} /> : "Submit"}
            </button>
            <p className={Classes.alt}>
              <button type="button" className={Classes.link} onClick={() => setMode("signin")}>
                Back to login
              </button>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
export default Login;
